import React from 'react';

function ChannelFilterInfo({ notificationChannels, channelFilter }) {
  return (
    <div className="channels" style={{ padding: '20px 0px', textAlign: 'center' }}>
      Dieser Post erscheint automatisch im Channel{' '}
      <b>#{notificationChannels.filter(channelFilter).map((channel) => channel.name)}</b> Der Beitrag ist nur sichtbar
      für alle App-User, welche dieses Profil im Erstsemester-Bereich ausgewählt haben.
    </div>
  );
}

export default ChannelFilterInfo;
